import { Observable } from 'rxjs';
import { AIPromptCore } from '@empathy/survey/base';

import { TranscribedAudio } from './transcribed-audio.interface';

export class AIPrompt extends AIPromptCore {
  transcription$: Observable<TranscribedAudio>;

  constructor(questionText: string, completed: boolean = false) {
    super(questionText, completed);
  }
}
